module.exports = __webpack_public_path__ + "static/media/geometry_1@2x.872dbfe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/personalProject/geometry_1@2x.png
// module id = 189
// module chunks = 0